import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "name",
    "wineColour",
    "wineStyle",
    "wineSweetness",
    "vintageYear",
  ];

  connect() {
    console.log("Organization wine entry form controller connected");
    // This controller is now only for interactive features, not form submission handling
  }

  validate(event) {
    console.log(
      "Form validation triggered - allowing submission to proceed to server"
    );

    // Always allow form submission to proceed to server-side validation
    // This controller is now only for interactive features, not validation blocking
    this.hideClientSideErrors();
  }

  showClientSideErrors(errors) {
    const errorContainer = document.getElementById("client-side-errors");
    const errorList = document.getElementById("client-side-errors-list");

    if (errorContainer && errorList) {
      errorList.innerHTML = "";
      errors.forEach((error) => {
        const li = document.createElement("li");
        li.textContent = error;
        errorList.appendChild(li);
      });
      errorContainer.classList.remove("hidden");
      // Add smooth fade-in effect
      errorContainer.style.opacity = 0;
      errorContainer.style.transition = "opacity 0.4s";
      setTimeout(() => {
        errorContainer.style.opacity = 1;
      }, 10);
    }
  }

  hideClientSideErrors() {
    const errorContainer = document.getElementById("client-side-errors");
    if (errorContainer) {
      errorContainer.classList.add("hidden");
      errorContainer.style.opacity = 0;
    }
  }
}
